
import { Vue } from 'vue-property-decorator';

export default class MaterialCard extends Vue { }
